import { paginatedTransform, rawTransform } from 'src/services/skuit/utils'
import { Case, PaginatedResponse } from '../../api/models'

import { API, CustomAxiosConfig } from './types'
import { ExportFilters } from '../skuit/types'
import fileDownload from 'js-file-download'

export interface ExportProps {
  fields: string[],
  exportFilters?: ExportFilters,
}

export class Cases {
  api: API

  constructor(api: API) {
    this.api = api
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<Case>> => {
    const response = await this.api.get('/logistics/cases', config)
    return paginatedTransform(Case)(response.data)
  }

  create = async (data: any, config: CustomAxiosConfig = {}): Promise<Case> => {
    const response = await this.api.post('/logistics/cases', data, config)
    return rawTransform(Case)(response.data)
  }

  patch = async (slug: string, data: any, config: CustomAxiosConfig = {}): Promise<Case> => {
    const response = await this.api.patch(`/logistics/cases/${slug}`, data, config)
    return rawTransform(Case)(response.data)
  }

  export = async ({ fields, exportFilters }: ExportProps) => {
    const guid: string | undefined = exportFilters?.guid
    const params = { fields: fields.join(','), products: guid }
    const response = await this.api.axiosInstance({
      url: '/logistics/cases/export',
      params,
      responseType: 'blob',
    })
    fileDownload(response.data, `cases_product_${guid}.csv`)
  }
}
